module.exports = __webpack_public_path__ + "static/img/kangaroos.cf5b114.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/melbourne/kangaroos.jpg
// module id = 122
// module chunks = 1